import { RadioButton } from '@/components/RadioButton';
import { LabradorComponent } from '@/types/component';

export const LabradorRadioButton: LabradorComponent = ({ type, data, meta }) => {
  return <RadioButton label={data.label} options={data.options} />;
};
